if (!customElements.get('discount-input')) {
    class DiscountInput extends HTMLElement {

        constructor() {
            super();

            this.currentBonusBalance = 0;

            this.token = this.dataset.token;
            this.date = this.dataset.date;

            this.discounts = JSON.parse(this.querySelector('[data-discounts]').innerHTML);
            this.discount = this.querySelector('[data-discount]');
            this.submit = this.querySelector('[data-submit]');
            this.submit?.addEventListener('click', this.handleSubmit.bind(this));
            this.submitMax = this.querySelector('[data-submit-max]');
            this.submitMax?.addEventListener('click', this.handleSubmitMax.bind(this));

            this.submitBonus = this.querySelector('[data-submit-bonus]');
            this.submitBonus?.addEventListener('click', this.handleSubmitBonus.bind(this));
            this.bonusAmount = this.querySelector('[data-bonus-amount]');

            this.input = this.querySelector('input');

            this.appliedDiscountCodes = document.querySelectorAll('[data-discount-code]').forEach((discount) => {
                discount.addEventListener('click', this.handleClickDiscount.bind(this, discount));
            })

            this.input.addEventListener('keypress', (e) => {
                if (e.key === 'Enter') {
                    this.handleSubmit();
                }
            });

            this.query = `mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
                cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
                    cart {
                        id
                        discountCodes {
                            code
                        }
                    }
                    userErrors {
                        field
                        message
                    }
                    warnings {
                        code
                        message
                    }
                }
            }`;
        }

        async connectedCallback() {

            this.submitBonus.disabled = true;
            this.submitBonus.classList.add('is-loading');
            this.submitBonus.setAttribute('aria-disabled', 'true');

            this.submitMax.disabled = true;
            this.submitMax.classList.add('is-loading');
            this.submitMax.setAttribute('aria-disabled', 'true');

            this.bonusAmount.disabled = true;
            this.bonusAmount.setAttribute('aria-disabled', 'true');

            const bonusPointResponse = await this.fetchCurrentBonusAmount();
            const { getting_bonuspoints } = bonusPointResponse;
            // const getting_bonuspoints = 500000;
            this.currentBonusBalance = parseFloat(getting_bonuspoints);

            const lablel = this.querySelector('[data-bonus-label]');
            const text = lablel?.getAttribute('data-text');
            lablel.innerHTML = text.replace('##AMOUNT##', parseFloat(getting_bonuspoints) > 0 ? window.formatMoney(getting_bonuspoints * 100) : window.formatMoney(0));

            this.submitBonus.classList.remove('is-loading');
            this.submitMax.classList.remove('is-loading');

            if (getting_bonuspoints <= 0) return;

            this.submitBonus.disabled = false;
            this.submitBonus.setAttribute('aria-disabled', 'false');

            this.submitMax.disabled = false;
            this.submitMax.setAttribute('aria-disabled', 'false');

            this.bonusAmount.disabled = false;
            this.bonusAmount.setAttribute('aria-disabled', 'false');

        }

        async fetchCurrentBonusAmount() {

            if (window.customer?.currentUserNumber?.startsWith('b2b_')) {
                return { getting_bonuspoints: 0 };
            }

            const preservedAmount = localStorage.getItem(`${window.customer.currentUserNumber}_bonus_balance`);

            if (preservedAmount) {
                try {
                    const { bonus_balance } = JSON.parse(preservedAmount);
                    return bonus_balance;
                } catch (e) {
                    console.log(e);
                }
            }

            const response = await fetch('/apps/stroetmann/api/v1/users/bonus_balance', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    customerId: window.customer.id,
                    userName: window.customer.userName,
                    userNumber: window.customer.currentUserNumber,
                    dateFrom: this.transformDate(new Date()),
                    dateTo: this.transformDate(window.customer?.selectedDeliveryDate ?? new Date()),
                    //dateFrom: '31129999',
                    //dateTo: '31129999'
                })
            });

            const { bonus_balance } = await response.json();

            localStorage.setItem(`${window.customer.currentUserNumber}_bonus_balance`, JSON.stringify({
                bonus_balance: bonus_balance[0]
            }));

            return bonus_balance[0];
        }

        async handleClickDiscount(e) {

            e.classList.add('clicked');

            const request = await fetch(`${window.theme.routes.cart}.js`);
            const cart = await request.json();

            const variables = {
                "cartId": `gid://shopify/Cart/${cart.token}`,
                "discountCodes": this.discounts.codes.filter((current) => current != e.dataset.code)
            };

            await fetch('/api/2024-10/graphql.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': this.token
                },
                body: JSON.stringify({ query: this.query, variables: variables })
            });

            this.render();
        }

        async handleSubmit() {

            if (this.discount.value.trim() == '') return;

            this.submit.disabled = true;
            this.submit.classList.add('is-loading');
            this.submit.setAttribute('aria-disabled', 'true');

            const request = await fetch(`${window.theme.routes.cart}.js`);
            const cart = await request.json();

            const variables = {
                "cartId": `gid://shopify/Cart/${cart.token}`,
                "discountCodes": [...this.discounts.codes, this.discount.value]
            };

            await fetch('/api/2024-10/graphql.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': this.token
                },
                body: JSON.stringify({ query: this.query, variables: variables })
            });

            this.render();
        }

        async handleSubmitMax() {

            if (this.currentBonusBalance === 0) return;

            let total = this.getTotalCartValue();

            if (total == 0) return;

            console.log(`cart items total >>`, (total / 100));
            console.log(`this.currentBonusBalance >>`, this.currentBonusBalance);

            const totalBonusBalance = +this.currentBonusBalance;
            const cartTotal = total / 100;
            const inputBonusValue = '';

            this.bonusAmount.value = this.calculateUsableBonus({ totalBonusBalance, cartTotal, inputBonusValue });

            // this.bonusAmount.value = this.currentBonusBalance / 100;
            // this.bonusAmount.value = this.currentBonusBalance;

            this.handleSubmitBonus();
        }

        calculateUsableBonus({ totalBonusBalance, cartTotal, inputBonusValue }) {
            if (inputBonusValue === '' || isNaN(inputBonusValue)) {
                const balance = Number(totalBonusBalance) || 0;
                const cart = Number(cartTotal) || 0;
                return Math.max(0, Math.min(balance, cart));
            } else {
                const balance = Number(totalBonusBalance) || 0;
                const cart = Number(cartTotal) || 0;
                const input = Number(inputBonusValue) || 0;
                return Math.max(0, Math.min(input, balance, cart));
            }
        }

        getTotalCartValue() {
            const { items } = LocalCart.getState();
            let total = 0;
            if (items.length) {
                items.forEach(item => {
                    if (!item.properties['_deposit']) {
                        total += Number(item.properties['_price']) * item.quantity;
                    }
                });
            }
            return total;
        }

        async handleSubmitBonus() {

            if (this.bonusAmount.value.trim() === '') {
                this.bonusAmount.value = this.bonusAmount.getAttribute('value');
                return;
            };

            // if (parseInt(this.bonusAmount.value) > this.currentBonusBalance * 100) {
            //     this.bonusAmount.value = this.currentBonusBalance / 100;
            // }

            let total = this.getTotalCartValue();
            if (total == 0) return;

            const totalBonusBalance = +this.currentBonusBalance;
            const cartTotal = total / 100;
            const inputBonusValue = parseFloat(this.bonusAmount.value);

            console.log(`inputBonusValue >>`, inputBonusValue)

            this.bonusAmount.value = this.calculateUsableBonus({ totalBonusBalance, cartTotal, inputBonusValue });

            this.bonusAmount.disabled = true;

            this.submitBonus.disabled = true;
            this.submitBonus.classList.add('is-loading');
            this.submitBonus.setAttribute('aria-disabled', 'true');

            this.submitMax.disabled = true;
            this.submitMax.classList.add('is-loading');
            this.submitMax.setAttribute('aria-disabled', 'true');

            const bonusValueAmt = Number(this.bonusAmount.value);
            window.bonusAmountValue = !isNaN(bonusValueAmt) && bonusValueAmt > 0 ? bonusValueAmt.toFixed(2) : null; //used in component-checkout.js file.

            const attrObj = {
                "bonus_amount": !isNaN(bonusValueAmt) && bonusValueAmt > 0 ? bonusValueAmt.toFixed(2) : '',
                "bonus_amount_max": Number(this.currentBonusBalance)
            }

            LocalCart.updateAttr(attrObj);
            // Local cart update event so latest cart saved to metafield
            if (sharedCart && Object.keys(sharedCart).length) {
                await sharedCart.handleCartChange();
            }

            this.render();
        }

        async render() {
            const mainSectionId = document.getElementById('cart-items').dataset.section;

            const sections = [];

            if (mainSectionId) sections.push(mainSectionId);

            if (!sections.length) return;

            const addResponse = await fetch(`/cart?sections=${sections.join(',')}&sections_url=${window.location.pathname}`);

            const addResponseJson = await addResponse.json();

            const mainCartTemplate = document.createElement('template');
            mainCartTemplate.innerHTML = addResponseJson[mainSectionId];;
            const mainCartEl = mainCartTemplate.content.querySelector(`#shopify-section-${mainSectionId}`);
            document.querySelector('.cc-main-cart').innerHTML = mainCartEl.innerHTML;
        }

        transformDate(timestamp) {
            const date = new Date(timestamp);
            const day = String(date.getDate()).padStart(2, '0');     // Pads single digits with a leading 0
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so we add 1
            const year = date.getFullYear();
            const formattedDate = `${day}${month}${year}`;
            return formattedDate;
        }
    }

    customElements.define('discount-input', DiscountInput);
}